import axios from "axios";
import { FETCH_SUBSCRIBE_TO_PETS, FETCH_SUBSCRIBE_NOTIFICATIONS, FETCH_SUBSCRIBE_TO_PETS_BY_MRID,DELETE_SUBSCRIBER, SEND_PROMOCODE_TO_SUBSCRIBERS, FETCH_SUBSCRIBERS_TO_RECEIVE_PROMO, FETCH_SUBSCRIBER_REPLIES, FETCH_LEAD_SUBSCRIBED_CUSTOMERS_VIA_MEDICAL_RECORD_ID,
         UPDATE_SUBSCRIBED_TO_PET, interceptor } from ".";
import store from "../store";

interceptor(axios, store);

export function fetchSubscribeToPet(field,data) {
  return {
    type: FETCH_SUBSCRIBE_TO_PETS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/subscribe-to-pet/option/${field}/${data.startDate}/${data.endDate}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

export function fetchSubscribeNotifications() {
  return {
    type: FETCH_SUBSCRIBE_NOTIFICATIONS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/subscribe-to-pet/get-subscribe-notifications`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

export function getNotificationsByMedicalRecord(id) {
  return {
    type: FETCH_SUBSCRIBE_TO_PETS_BY_MRID,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/subscribe-to-pet/getNotificationsByMedicalRecord/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

export function deleteSubscriber(id) {
  return {
    type: DELETE_SUBSCRIBER,
    payload: axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/core/subscribe-to-pet/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function sendPromoNotifications(data) {
  return {
    type: SEND_PROMOCODE_TO_SUBSCRIBERS,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/subscribe-to-pet/send-promos-to-subscribers`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchSubscribersToReceivePromo(data) {
  return {
    type: FETCH_SUBSCRIBERS_TO_RECEIVE_PROMO,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/subscribe-to-pet/get-subscriber-count-to-receive-promo`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchSubscriberReplies() {
  return {
    type: FETCH_SUBSCRIBER_REPLIES,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/subscribe-to-pet/get-replies`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

export function getSubscribedCustomersViaMedicalRecordId(id) {
  return {
    type: FETCH_LEAD_SUBSCRIBED_CUSTOMERS_VIA_MEDICAL_RECORD_ID,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/subscribe-to-pet/lead/customers/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

export function updateSubscribedToPet(id,data) {
  return {
    type: UPDATE_SUBSCRIBED_TO_PET,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/subscribe-to-pet/${id}`,data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

